import { MouseEvent, useState } from 'react';
import { Form } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { LoadingOutlined } from '@ant-design/icons';

import If from 'global/Common/If';
import BaseSecuritiesModal from 'global/Securities/components/Modal/BaseSecuritiesModal';
import Checkbox from 'global/Securities/components/Checkbox';
import type { BaseSecuritiesModalProps } from 'global/Securities/components/Modal/BaseSecuritiesModal';
import { TnCFeaturesIDEnum } from 'global/Securities/types/termsAndCondition';

import {
  useAcceptTnc,
  useGetTncByFeatures,
} from 'global/Securities/api/useTermAndConditionsAPI';
import {
  ActionWrapper,
  AgreementTextWrapper,
  AgreementWrapper,
  Container,
  NextButton,
  TnCWrapper,
  TnCFrame,
  TnCLoadingWrapper,
} from './AutoOrderTnc.styled';

export default function AutoOrderTnc({
  onCancel = () => {},
  onSubmit = () => {},
  ...props
}: Readonly<BaseSecuritiesModalProps>) {
  const [form] = Form.useForm();
  const [tncAgreed, setTncAgreed] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [iframeLoading, setIframeLoading] = useState<boolean>(true);

  const { data, refetch } = useGetTncByFeatures([TnCFeaturesIDEnum.AUTO_ORDER]);

  const mutationFn = useAcceptTnc();

  const [{ feature_id: featureId, version: TncVersion, url }] =
    data?.acceptance_letters ?? [{}];

  const handleCancel = (e: MouseEvent<HTMLElement>) => {
    onCancel(e);
  };

  const handleCheckboxChange = (event: CheckboxChangeEvent) => {
    setTncAgreed(event.target.checked);
  };

  const handleSubmit = async () => {
    if (TncVersion) {
      setLoading(true);
      const payload = {
        feature_id: String(featureId),
        version: TncVersion,
        is_accepted: tncAgreed,
      };

      mutationFn.mutateAsync([payload], {
        onSuccess: (res) => {
          if (res) {
            setTncAgreed(true);
            onSubmit();
            refetch();
          }
        },
      });
      setLoading(false);
    }
  };

  return (
    <BaseSecuritiesModal
      title="Syarat & Ketentuan Auto Order"
      onCancel={handleCancel}
      className="modal-tnc-auto-order"
      transitionName=""
      {...props}
    >
      <Container onClick={(e) => e.stopPropagation()}>
        <Form form={form}>
          <TnCWrapper>
            <If condition={iframeLoading}>
              <TnCLoadingWrapper>
                <LoadingOutlined
                  style={{
                    color: '#00AB6B',
                    fontSize: '20px',
                  }}
                />
              </TnCLoadingWrapper>
            </If>

            <If condition={!!url}>
              <TnCFrame
                title="auto-order-tnc"
                src={url}
                id="auto-order-tnc"
                onLoad={() => setIframeLoading(false)}
              />
            </If>
          </TnCWrapper>

          <Form.Item style={{ marginBottom: 0 }}>
            <AgreementWrapper>
              <Checkbox checked={tncAgreed} onChange={handleCheckboxChange} />

              <AgreementTextWrapper onClick={() => setTncAgreed(!tncAgreed)}>
                Saya menyetujui Syarat & Ketentuan Penggunaan{' '}
                <span>Auto Order</span> di atas.
              </AgreementTextWrapper>
            </AgreementWrapper>
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <ActionWrapper>
              <NextButton
                onClick={handleSubmit}
                type="primary"
                disabled={!tncAgreed || loading}
                loading={loading}
              >
                Lanjut
              </NextButton>
            </ActionWrapper>
          </Form.Item>
        </Form>
      </Container>
    </BaseSecuritiesModal>
  );
}
